import { type Field } from "./aggregate";

// Titles identifying a plan-for-impact field. Non-profits answer the field
// literally titled "Plan for impact"; for-profits answer "Positive impact
// plan (for-profit)" and "Incentive alignment plan" instead.
export const PLAN_FOR_IMPACT_TITLE_KEYWORDS = [
  "plan for impact",
  "positive impact plan",
  "incentive alignment plan",
];

export function findPlanForImpactFields(fields: Field[]): Field[] {
  return fields.filter((f) => {
    // Fields are soft-deleted (status flips to "deleted" but the field stays
    // in the form), and stale responses can linger — don't let a deleted
    // plan field contribute text.
    if (f.status !== "active" || f.type !== "question") return false;
    const title = f.title.toLowerCase();
    return PLAN_FOR_IMPACT_TITLE_KEYWORDS.some((kw) => title.includes(kw));
  });
}

/**
 * Resolve the combined "Plan for Impact" text for a proposal from its form
 * fields and field responses. Returns null when no matching field has a
 * non-empty response.
 */
export function resolvePlanForImpact(
  fields: Field[],
  fieldResponses: Record<string, string>,
): string | null {
  const responses = findPlanForImpactFields(fields)
    .map((field) => fieldResponses[field.id]?.trim())
    .filter((response): response is string => Boolean(response));
  if (responses.length === 0) return null;
  return responses.join("\n\n");
}
